import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'REGION/CITIES/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetCities(client) {
  try {
    const data = { tp: 1 };
    const response = yield client.post('/region/list', { data });
    yield put(actions.loadSuccess(response.result.data));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
